import { Readings, Gateway, Meter, Sensors } from "../../api"
import { auth, db, timeStamp } from '../../plugins/firebase'
import firebase from 'firebase/app'

const state = {
    meters: [],
    capacityMeters: [],
    currMeters: [],
    collection: null,
    lastReadings: null,
    userInfo: null,
    key: '94260d97055e949eada6d5d9b569c49a',
    metersAPI: [],
    meterStatus: false,
    watts: [],
    arrayMeterLinks: [],
    comments: [], allComments: [],
    metersON: 0, metersUP: 0, metersDOWN: 0, metersOFF: 0, metersOUT: 0,
    arrayON: [], arrayUP: [], arrayDOWN: [], arrayOFF: [], arrayOUT: [],
    arrayTemps: [], rangeTemps: [], rangeArrayTemps: [],
    arrayLights: [], rangeLights: [], rangeArrayLights: [],
    arrayHumids: [], rangeHumids: [], rangeArrayHumids: [],
    groupMeters: []
};

const getters = {
    getMeter: state => meter => state.meters.find(m => m.name === meter || m.circuit === meter),
    getMeterData: state => meter => state.meters.find(m => m.name === meter || m.circuit === meter).data,
    getLastReading: state => meter => state.lastReadings.find(m => m.meter === meter),
    getAll: state => state.meters.map( m => ({ name: m.name, circuit: m.circuit })),
    getLocations: state => state.meters.map( m => m.location )
};

const actions = {
    async setCollectionDb({ commit, dispatch }){
        return new Promise(async (resolve, reject) =>{
            if(auth.currentUser){  
                await commit('UPDATE_USER_INFO', auth.currentUser.uid) 
                await commit('UPDATE_COLLECTION', auth.currentUser.uid)
                await dispatch('fetchUserMeters')
                await dispatch('lastReadings')
                await dispatch('fetchUserGroups')
                await dispatch('valuesTemps')
                await dispatch('retrieveAllComments')
                return resolve()
            }else{
                commit('UPDATE_COLLECTION')
                commit('SET_METERS', [])
                return resolve()
            }
        })
    },
    async fetchUserMeters({ commit }){ 
        return new Promise(async (resolve, reject) =>{
            try {
                let response = await db.collection(state.collection).get()
                let arrOriginal = response.docs.map( m => m.data())
                let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                let myArray2 = response.docs.map( m => m.data().circuit)
                let metersOrdered2 = myArray2.sort(collator.compare)
                let nwArray = []
                for (let index = 0; index < metersOrdered2.length; index++) {
                    let element = metersOrdered2[index];
                    let e = arrOriginal.find(m => m.circuit === element)
                    nwArray.push(e)
                }
                commit('SET_METERS', nwArray)
                return resolve()
            } catch (error) {
                commit('SET_METERS', [])
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    async updateMeterFromApi({ state, commit }, meter_id){
        const meter = state.meters.find( m => m.name === meter_id )
        if(!meter) return
        return new Promise((resolve, reject) => {
            Meter.get({ id: meter.name, key: meter.key })
            .then( response => {
                const { data } = response
                commit('UPDATE_METER_API', data)
                let m_ON = 0
                let m_OFF = 0
                let m_OUT = 0
                for (let index = 0; index < state.meters.length; index++) {
                    if(state.meters[index].active){
                        if(state.meters[index].control){
                            m_ON += 1
                        }else{
                            m_OFF += 1
                        }
                    }else{
                            m_OUT += 1
                    }  
                }
                resolve()
            })
            .catch( err => reject(err))
        })
    },
    async fetchAPIstatus({ state, commit }, meter_id){
        const meter = state.meters.find( m => m.name === meter_id )
        if(!meter) return
        return new Promise((resolve, reject) => {
            Meter.get({ id: meter.name, key: meter.key }) 
            .then( response => {
                const { data } = response
                commit('UPDATE_METER_STATUS', data)
                resolve()
            })
            .catch( err => reject(err)) 
        })
    },
    async checkMeter({ state, commit }, gateway ){
        console.log(gateway)
        return new Promise(async (resolve, reject) => {
            try {
                let gw = state.meters.find( m => m.gateway.id == gateway.id)
                console.log(gw)
                if(gw) resolve()
            } catch (error) {
                console.log(error)
                reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    async addMeters({ state, commit }, data ){
        return new Promise(async (resolve, reject) => {
            try {
                let gateway = state.meters.find( m => m.gateway.id == data.gateway.id)
                if(gateway) reject({ message: 'Gateway ya registrado'})

                let batch = db.batch()
                let meters = data.meters.map((m) =>{
                    let meter = { 
                        name: m.name,
                        key: m.key,
                        nlines: m.nlines,
                        circuit: m.circuit,
                        gateway: data.gateway,
                        capacity: m.capacity,
                        fare: m.fare
                    }

                    meter.location = new firebase.firestore.GeoPoint(
                        parseFloat(m.latitude), 
                        parseFloat(m.longitude)
                    )

                    batch.set(db.doc(`${state.collection}/${m.name}`) , meter);
                    return meter
                })

                await batch.commit()

                commit('ADD_METERS', meters)
                resolve()
            } catch (error) {
                console.log(error)
                reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    editMeter({state, commit}, meter_updated){
        return new Promise(async (resolve, reject) => {
            try {
                let index = state.meters.findIndex( m => m.name == meter_updated.name)
                if(index < 0) reject({ message: 'Medidor no registrado'})
                
                meter_updated.location = new firebase.firestore.GeoPoint(
                    parseFloat(meter_updated.latitude), 
                    parseFloat(meter_updated.longitude)
                )
                
                delete meter_updated.longitude
                delete meter_updated.latitude
                
                await db.doc(`${state.collection}/${meter_updated.name}`).update({
                    circuit: meter_updated.circuit,
                    location: meter_updated.location,
                    capacity: meter_updated.capacity,
                    fare: meter_updated.fare,
                })
                commit('UPDATE_METER', { meter: meter_updated, index})
                resolve()
            } catch (error) {
                reject()
            }
        })
    },
    async checkIssue({state, commit}, data){
        let {meter_id, issue} = data
        return new Promise(async (resolve, reject) => {
            try {
                let index = state.meters.findIndex( m => m.name == meter_id)
                let response = await db.collection(state.collection).doc(meter_id).update({
                    issue: issue
                })
                commit('REPORT_ISSUE', {meter_id, index, issue})
                resolve()
            } catch (error) {
                reject()
            }
        })
    },
    async uncheckIssue({state, commit}, data){
        let {meter_id, issue} = data
        return new Promise(async (resolve, reject) => {
            try {
                let response = await db.collection(state.collection).doc(meter_id).update({
                    issue: issue
                })
                commit('REPORT_ISSUE', {meter_id, index, issue})
                resolve()
            } catch (error) {
                reject()
            }
        })
    },
    async deleteMeter({state, commit}, meter_id){
        return new Promise(async (resolve, reject) => {
            try {
                let m = state.meters.find(m => m.circuit === meter_id)
                await db.collection(state.collection).doc(m.name).delete()
                commit('DELETE_METER', meter_id)
                resolve()
            } catch (error) {
                reject()
            }
        })
    },
    controlMeter({commit}, payload) {
        const { meter, control, fotocelda } = payload
        return new Promise(async (resolve, reject) => {
            try {
                await Meter.control(meter, { control, fotocelda })
                commit('UPDATE_METER_CONTROL', payload)
                return resolve({message: 'Exito' })
            } catch (error) {
                return reject({ message: '¡Ops! Ocurrio un error' }) 
            }
        })
    },
    scheduleMeter({commit}, payload) {
        const { meter, data } = payload
        return new Promise(async (resolve, reject) => {
            try {
                await Meter.schedule(meter, data)
                commit('UPDATE_METER_SCHEDULE', { meter, ...data })
                return resolve({message: 'Exito' })
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' }) 
            }
        })
    },
    activeSuntime({ commit }, payload){
        const { meter, data } = payload
        return new Promise(async (resolve, reject) => {
            try {
                await Meter.suntime(meter, data)
                commit('UPDATE_METER_SUNTIME', {meter, data})
                return resolve({message: 'Exito' })
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' }) 
            }
        })
    },
    fetchUserGroups({ state, commit }){
        return new Promise(async (resolve, reject) => {
            try {
                let { data } = await Readings.last(
                    state.meters.map((m) => m.name)
                )
                let arrayGroups = []; let groupNames = []; let finalGroups = []
                for (let index = 0; index < data.length; index++) {
                    let element = data[index][0];
                    if (element){
                        let circuit = state.meters.find(m => m.name === element.meter)
                        if(circuit.group != undefined){
                            arrayGroups.push(circuit)
                        }
                    }
                }

                for (let index = 0; index < arrayGroups.length; index++) {
                    groupNames.push(arrayGroups[index].group)
                }
                let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                let groupNamesOrdered = groupNames.sort(collator.compare)
                let newArrNames = []
                newArrNames.push(groupNamesOrdered[0])
                for (let index = 0; index < groupNamesOrdered.length-1; index++) {
                    if(groupNamesOrdered[index] != groupNamesOrdered[index+1]) newArrNames.push(groupNamesOrdered[index+1])
                }
                for (let index = 0; index < newArrNames.length; index++) {
                    const element = newArrNames[index];
                    let arr = []
                    arrayGroups.forEach(m => {
                        if(m.group === element) {
                            arr.push(m)
                        }
                    })
                    finalGroups.push({
                        name: element,
                        meters: arr
                    })
                }
                commit('SET_GROUPS', finalGroups)   
                return resolve()
            } catch (error) {
                return reject()
            }
            
        })
    },
    lastReadings({ state, commit }){
        return new Promise(async (resolve, reject) => {
            try {
                let { data } = await Readings.last(
                    state.meters.map((m) => m.name)
                )
                commit('UPDATE_LAST_READS', data.map((record) => record[0]))
                let arrayWatts = []; let arrayValues = []; 
                let array_ON = []; let array_UP = []; let array_DOWN = []; let array_OFF = []; let array_OUT = []
                let userData = await state.userInfo.get()
                let minToDgr = userData.data().minutesToDanger
                let m_ON = 0; let m_UP = 0; let m_DOWN = 0; let m_OFF = 0; let m_OUT = 0
                let arrayLinks = []; let arrayGroups = []; let groupNames = []; let finalGroups = []
                for (let index = 0; index < data.length; index++) {
                    let element = data[index][0];
                    if (element){
                        let time = new Date().getTime() - new Date(element.timestamp).getTime()
                        let m = element.lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2)
                        let circuit = state.meters.find(m => m.name === element.meter)
                        
                        if(circuit.link != undefined){
                            let obj = {name: circuit.circuit, url: circuit.link}
                            arrayLinks.push(obj)
                        } else {
                            let lat = circuit.location.latitude
                            let lng = circuit.location.longitude
                            const d = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`)
                            const d_json = await d.json()
                            let address = null
                            let obj = {}
                            if (d_json.hasOwnProperty('plus_code')) {
                                address = d_json.plus_code.global_code
                                let arr_add = address.split('')
                                let arr_new = []
                                for (let index = 0; index < arr_add.length; index++) {
                                    const element = arr_add[index]
                                    if (element != '+') {
                                        arr_new.push(element)
                                    } else {
                                        let prov = '%2B'
                                        arr_new.push(prov)
                                    }
                                }
                                let arr_join = arr_new.join('')
                                let gMapLink = `https://www.google.com/maps/place/${arr_join}`
                                obj = {name: circuit.circuit, url: gMapLink}
                                arrayLinks.push(obj)
                            } else {
                                address = 'N/A'
                                console.log('No hay', address)
                                obj = {name: circuit.circuit, url: address}
                                arrayLinks.push(obj)
                            }
                            await db.doc(`${state.collection}/${circuit.name}`).update({ link: obj.url })
                        }

                        let limOff = Number(circuit.capacity)
                        let limUp = limOff + (limOff * 0.1)
                        let limDown = limOff - (limOff * 0.1)
                        let limReg = limOff - (limOff * 0.95)
                        if (minToDgr * 60 * 1000 < time) {
                            m_OUT += 1
                            let e_OUT = state.meters.find(m => m.name === element.meter)
                            array_OUT.push(e_OUT)
                        } else if (m < limReg) {
                            m_OFF += 1
                            let e_OFF = state.meters.find(m => m.name === element.meter)
                            array_OFF.push(e_OFF)
                        } else if (m >= limReg && m < limDown) {
                            m_DOWN += 1
                            m_ON += 1
                            let e_DOWN = state.meters.find(m => m.name === element.meter)
                            array_DOWN.push(e_DOWN)
                            array_ON.push(e_DOWN)
                        } else if (m >= limDown && m < limUp) {
                            m_ON += 1
                            let e_ON = state.meters.find(m => m.name === element.meter)
                            array_ON.push(e_ON)
                        } else if (m >= limUp) {
                            m_UP += 1
                            m_ON += 1
                            let e_UP = state.meters.find(m => m.name === element.meter)
                            array_UP.push(e_UP)
                            array_ON.push(e_UP)
                        }
                        arrayWatts.push(m)
                    }
                }
                commit('SET_ARRAY_LINKS', arrayLinks)
                commit('SET_ARRAY_ON', array_ON); commit('SET_ARRAY_UP', array_UP); commit('SET_ARRAY_DOWN', array_DOWN)                
                commit('SET_ARRAY_OFF', array_OFF); commit('SET_ARRAY_OUT', array_OUT)
                commit('SET_METERS_ON', m_ON); commit('SET_METERS_UP', m_UP); commit('SET_METERS_DOWN', m_DOWN)
                commit('SET_METERS_OFF', m_OFF); commit('SET_METERS_OUT', m_OUT)
                let min = Math.min(...arrayWatts); let max = Math.max(...arrayWatts)
                let div = 6; let sum = min; let delta = (max-min) / div
                arrayValues.push(min)
                for (let index = 0; index <  div; index++) {
                    sum += delta
                    arrayValues.push(Number(sum.toFixed(2)))
                }
                commit('SET_WATTS_ARRAY', arrayValues)               
                return resolve()
            } catch (error) {
                return reject()
            }
            
        })
    },
    async valuesTemps({ state, commit }){
        const userData = await state.userInfo.get()
        const city = userData.data().city
        const apiData = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city},mx&appid=${state.key}`)
        const apiRes = await apiData.json()
        let h = Math.round(apiRes.main.humidity)
        let t = await Math.round((apiRes.main.temp - 273.15) * 9/5 + 32)
        let arrTemp = []; let tValues = []
        let arrLight = []; let lValues = []
        let arrHumid = []; let hValues = []
        
        for (let index = 0; index < state.meters.length; index++) {
            const element = state.meters[index];
            const m = element.circuit
            let obj = {}
            let obj2 = {}
            let obj3 = {}
            const data = await Sensors.last(
                { id: element.name, key: element.key } 
            )
            if(data.data.temperature) {
                if(data.data.temperature.lastValue > 0 && data.data.temperature.lastValue <= 55) {
                    let tempF = Number(((data.data.temperature.lastValue * 9/5) + 32).toFixed(0))
                    tValues.push(tempF)
                    obj = {meter: m, temp: tempF}
                } else {
                    let tempD = Number(t)
                    tValues.push(tempD)
                    obj = {meter: m, temp: tempD}
                }
            } else {
                let tempD = Number(t)
                tValues.push(tempD)
                obj = {meter: m, temp: tempD}
            }
            if (data.data.light != undefined) {
                if(data.data.light.lastValue > 100){
                    obj2 = {meter: m, light: 100}
                    lValues.push(100)
                } else {
                    obj2 = {meter: m, light: data.data.light.lastValue}
                    lValues.push(data.data.light.lastValue)
                }
            } else {
                obj2 = {meter: m, light: 0}
                lValues.push(0)
            }
            
            if (data.data.humidity != undefined) {
                if(data.data.humidity.lastValue === null) {
                    obj3 = {meter: m, humidity: h}
                    hValues.push(h)
                }
                else {
                    obj3 = {meter: m, humidity: data.data.humidity.lastValue}
                    hValues.push(data.data.humidity.lastValue)
                }
            } else {
                obj3 = {meter: m, humidity: h}
                hValues.push(h)
            }
            arrTemp.push(obj)
            arrLight.push(obj2)
            arrHumid.push(obj3)
        }
        commit('SET_TEMPS_ARRAY', arrTemp)
        commit('SET_HUMID_ARRAY', arrHumid)
        commit('SET_LIGHT_ARRAY', arrLight)
        
        let div = 6
        let valTemp = []; let minT = Math.min(...tValues); let maxT = Math.max(...tValues); let sumT = minT; let deltaT = (maxT-minT) / div
        let arr01T = []; let arr12T = []; let arr23T = []; let arr34T = []; let arr45T = []; let arr56T = []
        valTemp.push(minT)
        for (let index = 0; index <  div; index++) {
            sumT += deltaT
            valTemp.push(Number(sumT.toFixed(0)))
        }
        commit('SET_VAL_TEMPS_ARRAY', valTemp)
        for (let index = 0; index < arrTemp.length; index++) {
            const element = arrTemp[index];
            if( element.temp >= valTemp[0] && element.temp <= valTemp[1] ){
                let e01 = state.meters.find(m => m.circuit === element.meter)
                arr01T.push(e01)
            } else if ( element.temp > valTemp[1] && element.temp <= valTemp[2] ){
                let e12 = state.meters.find(m => m.circuit === element.meter)
                arr12T.push(e12)
            } else if ( element.temp > valTemp[2] && element.temp <= valTemp[3] ){ 
                let e23 = state.meters.find(m => m.circuit === element.meter)
                arr23T.push(e23)
            } else if ( element.temp > valTemp[3] && element.temp <= valTemp[4] ){
                let e34 = state.meters.find(m => m.circuit === element.meter)
                arr34T.push(e34)
            } else if ( element.temp > valTemp[4] && element.temp <= valTemp[5] ){
                let e45 = state.meters.find(m => m.circuit === element.meter)
                arr45T.push(e45)
            } else {
                let e56 = state.meters.find(m => m.circuit === element.meter)
                arr56T.push(e56)
            }            
        }
        let allRangesTemp = [arr01T, arr12T, arr23T, arr34T, arr45T, arr56T]
        commit('SET_RANGES_TEMPS_ARRAY', allRangesTemp)
        
        let valHumid = []; let minH = Math.min(...hValues); let maxH = Math.max(...hValues); let sumH = minH; let deltaH = (maxH-minH) / div
        let arr01H = []; let arr12H = []; let arr23H = []; let arr34H = []; let arr45H = []; let arr56H = []
        valHumid.push(minH)
        for (let index = 0; index <  div; index++) {
            sumH += deltaH
            valHumid.push(Number(sumH.toFixed(0)))
        }
        commit('SET_VAL_HUMID_ARRAY', valHumid)
        for (let index = 0; index < arrHumid.length; index++) {
            const element = arrHumid[index];
            if( element.humidity >= valHumid[0] && element.humidity <= valHumid[1] ){
                let e01 = state.meters.find(m => m.circuit === element.meter)
                arr01H.push(e01)
            } else if ( element.humidity > valHumid[1] && element.humidity <= valHumid[2] ){
                let e12 = state.meters.find(m => m.circuit === element.meter)
                arr12H.push(e12)
            } else if ( element.humidity > valHumid[2] && element.humidity <= valHumid[3] ){ 
                let e23 = state.meters.find(m => m.circuit === element.meter)
                arr23H.push(e23)
            } else if ( element.humidity > valHumid[3] && element.humidity <= valHumid[4] ){
                let e34 = state.meters.find(m => m.circuit === element.meter)
                arr34H.push(e34)
            } else if ( element.humidity > valHumid[4] && element.humidity <= valHumid[5] ){
                let e45 = state.meters.find(m => m.circuit === element.meter)
                arr45H.push(e45)
            } else {
                let e56 = state.meters.find(m => m.circuit === element.meter)
                arr56H.push(e56)
            }            
        }
        let allRangesHumid = [arr01H, arr12H, arr23H, arr34H, arr45H, arr56H]
        commit('SET_RANGES_HUMID_ARRAY', allRangesHumid)

        let valLight = []; let minL = Math.min(...lValues); let maxL = Math.max(...lValues); let sumL = minL; let deltaL = (maxL-minL) / div
        let arr01L = []; let arr12L = []; let arr23L = []; let arr34L = []; let arr45L = []; let arr56L = []
        valLight.push(minL)
        for (let index = 0; index <  div; index++) {
            sumL += deltaL
            valLight.push(Number(sumL.toFixed(0)))
        }
        commit('SET_VAL_LIGHT_ARRAY', valLight)
        for (let index = 0; index < arrLight.length; index++) {
            const element = arrLight[index];
            if( element.light >= valLight[0] && element.light <= valLight[1] ){
                let e01 = state.meters.find(m => m.circuit === element.meter)
                arr01L.push(e01)
            } else if ( element.light > valLight[1] && element.light <= valLight[2] ){
                let e12 = state.meters.find(m => m.circuit === element.meter)
                arr12L.push(e12)
            } else if ( element.light > valLight[2] && element.light <= valLight[3] ){ 
                let e23 = state.meters.find(m => m.circuit === element.meter)
                arr23L.push(e23)
            } else if ( element.light > valLight[3] && element.light <= valLight[4] ){
                let e34 = state.meters.find(m => m.circuit === element.meter)
                arr34L.push(e34)
            } else if ( element.light > valLight[4] && element.light <= valLight[5] ){
                let e45 = state.meters.find(m => m.circuit === element.meter)
                arr45L.push(e45)
            } else {
                let e56 = state.meters.find(m => m.circuit === element.meter)
                arr56L.push(e56)
            }            
        }
        let allRangesLight = [arr01L, arr12L, arr23L, arr34L, arr45L, arr56L]
        commit('SET_RANGES_LIGHT_ARRAY', allRangesLight)
    },
    filteredMeters({ state, commit }, data){
        let metersFiltered = []
        switch (data) {
            case 'ON':
                metersFiltered = state.arrayON
                break;
            case 'OFF':
                metersFiltered = state.arrayOFF
                break;
            case 'OUT':
                metersFiltered = state.arrayOUT
                break;
            default:
                metersFiltered = state.meters
                break;
        }
        commit('FILTER_METERS', metersFiltered)
    },
    async metersLinks({ state, commit }){
        let linksArray = []
        for (let index = 0; index < state.meters.length; index++) {
            let m = state.meters[index].circuit
            let lat = state.meters[index].location.latitude
            let lng = state.meters[index].location.longitude
            let name = state.meters[index].name
            let response = await db.collection(state.collection).doc(name).get()
            let data = response.data()
            // console.log(data.link)
            if (data.link != undefined) {
                // console.log('Obteniendo de Firestore...')
                let obj = {name: m, url: data.link}
                linksArray.push(obj)
            } else {
                // console.log('Obteniendo de Geolocation API...')
                const data = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`)
                const data_json = await data.json()
                let address = null
                let obj = {}
                if (data_json.hasOwnProperty('plus_code')) {
                    address = data_json.plus_code.global_code
                    let arr_add = address.split('')
                    let arr_new = []
                    for (let index = 0; index < arr_add.length; index++) {
                        const element = arr_add[index]
                        if (element != '+') {
                            arr_new.push(element)
                        } else {
                            let prov = '%2B'
                            arr_new.push(prov)
                        }
                    }
                    let arr_join = arr_new.join('')
                    let gMapLink = `https://www.google.com/maps/place/${arr_join}`
                    obj = {name: m, url: gMapLink}
                    linksArray.push(obj)
                } else {
                    address = 'N/A'
                    obj = {name: m, url: address}
                    linksArray.push(obj)
                }
                await db.doc(`${state.collection}/${name}`).update({
                    link: obj.url
                })
            }
        }
        commit('SET_ARRAY_LINKS', linksArray)
        // console.log(linksArray)
    },
    async valuesWatts({ state, commit }){
        // console.log('Entering...')
        // let { data } = await Readings.last(
        //     state.meters.map((m) => m.name)
        // )
        // console.log(data)
        let { data } = await Readings.byMeter(
             { id: state.meters[2].name, key: state.meters[2].key }, { cnt: 60 } 
        )
        // console.log(data)
        // let { data2 } = await Readings.byMeter(
        //     { id: state.meters[2].name, key: state.meters[2].key, cnt: 60 }
        // )
        // console.log(data2)
    },
    queryReadings({ state }, data){
        const meter = state.meters.find((m) => m.name === data.meter);
        if(!meter) return []

        return new Promise((resolve, reject) => {
            Readings.byMeter(
                { id: meter.name, key: meter.key },
                data.query
            )
            .then((response) => {
                const { data } = response
                resolve(data)
            })
            .catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    },
    updateMeterData({ state, commit }, id_meter) {
        const meter = state.meters.find((m) => m.name === id_meter);
        const MINUTES_REFRESH = 15
        if(meter.data)
            if(( meter.data.length > 0 && (new Date().getTime() - meter.last_update < 1000 * 60 * MINUTES_REFRESH))) 
                    return false
        
        return new Promise((resolve, reject) => {
            Readings.byMeter(
                { id: meter.name, key: meter.key },
                { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 24 }
            )
                .then((response) => {
                    const { data } = response;
                    commit("SET_METER_DATA", { meter: id_meter, data: data })
                    resolve(true)
                })
                .catch((error) => {
                    console.log(error);
                    reject(false)
                });
        })
    },
    async getHistoricData({ state, dispatch }, data ){
        const meter = state.meters.find((m) => m.name === data.id_meter)
        return new Promise((resolve, reject) => {
            Readings.daySummary(
                meter.name,
                {
                    start: data.start || new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 
                    end: data.end || new Date().getTime() 
                }
            )
                .then((response) => {
                    const data = response
                    resolve({ data })
                })
                .catch((error) => {
                    console.log(error);
                    reject({ data: []})
                });
        })
    },
    async newComment({state, commit}, data){
        try {
            let {name, content, date, creationDate} = data
            const comm = await db.collection(state.collection).doc(name).collection("comments").add({
                'content': content,
                'date': date,
                'creationDate': creationDate,
            })
            let comment = {
                'content': content,
                'date': date,
            }
            commit('INSERT_COMMENT', comment)
        } catch (error) {
            console.log('Contenido no agregado')
        }
    },
    async getComments({state, commit}, meter){
        let comments = []
        await db.collection(state.collection).doc(meter).collection("comments").orderBy('creationDate','desc').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                comments.push(doc.data())
            });
            commit('DISPLAY_COMMENTS', comments)
        });
    },
    async retrieveAllComments({state, commit}){
        let comments = []
        let order = []
        let counter = 0
        let commMeter = state.meters
        for (let i = 0; i < commMeter.length; i++) {
            const element1 = commMeter[i];
            let comm = await db.collection(state.collection).doc(element1.name).collection("comments").orderBy('creationDate','desc').get()
            let c = comm.docs.map( m => m.data())
            let obj = {
                name: element1.name, 
                comments: c
            }
            comments.push(obj)
        }
        commit('RETRIEVE_COMMENTS', comments)
    },
    async deleteComment({state, commit}, data){
        let {name, creationDate} = data
        let res = await db.collection(state.collection).doc(name).collection("comments").where("creationDate", "==", creationDate)
        let foundComm = res.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                let id = doc.id
                let res_del = db.collection(state.collection).doc(name).collection("comments").doc(id)
                res_del.delete()
                commit('DELETE_COMMENT', creationDate)
            });
        })
    },
    async createNewGroup({state, commit}, data){
        await data.meters.forEach(element => {
            db.doc(`${state.collection}/${element.name}`).update({ group: data.name })
        })
        let arr = state.groupMeters
        arr.push(data)
        commit('SET_GROUPS', arr)
    },
    async editGroup({state, commit}, data){
        await data.newMeters.forEach(element => { db.doc(`${state.collection}/${element.name}`).update({ group: data.newName }) })
        let arr = state.groupMeters
        let group = arr.find(m => m.name === data.name)
        group.name = data.newName
        group.meters = data.newMeters
        arr = arr.filter(item => item.name !== data.name)
        arr.push(group)
    },
    async deleteFromGroup({state, commit}, data){
        await data.meters.forEach(element => { db.doc(`${state.collection}/${element.name}`).update({ group: firebase.firestore.FieldValue.delete() }) })
    },
    async deleteGroup({state, commit}, data){
        await data.meters.forEach(element => {
            db.doc(`${state.collection}/${element.name}`).update({ group: firebase.firestore.FieldValue.delete() })
        })
        let arr = state.groupMeters
        arr = arr.filter(item => item.name !== data.name)
        commit('SET_GROUPS', arr)
    },
    async resetMeters({ commit }){
        await commit('SET_METERS', [])
        await commit('SET_METERS_ON', 0)
        await commit('SET_METERS_OFF', 0)
        await commit('SET_METERS_OUT', 0)
    }

};

const mutations = {
    UPDATE_COLLECTION(state, user){
        user 
            ? state.collection = `users/${user}/meters`
            : state.collection = null
    },
    UPDATE_USER_INFO(state, user){
        user 
            ? state.userInfo = db.doc(`users/${user}`)
            : state.userInfo = null
    },
    UPDATE_LAST_READS(state, data){ state.lastReadings = data },
    SET_WATTS_ARRAY(state, data){ state.watts = data },
    SET_METER_DATA(state, payload) {
        const index = state.meters.findIndex((m) => m.name == payload.meter);
        state.meters[index].data = payload.data
        state.meters[index].last_update = new Date().getTime()
    },
    UPDATE_METER(state, payload){
        if(payload.index < 0) return
        let meter = state.meters[payload.index]
        meter.circuit = payload.meter.circuit
        meter.location = payload.meter.location
        meter.capacity = payload.meter.capacity
        state.meters[payload.index] = meter
    },
    UPDATE_METER_API(state, payload){
        const propToUpdate = ['active', 'control', 'currentVersion', 'fotocelda', 'meter_id', 'schedule', 'sim_id', 'suntime']
        const index = state.meters.findIndex( m => m.name === payload.name )
        if(index === -1) return
        propToUpdate.forEach(prop => {
            if(payload.hasOwnProperty(prop))
                state.meters[index][prop] = payload[prop]
                state.metersAPI.push(state.meters[index][prop])
        });
    },
    UPDATE_METER_STATUS(state, payload){
        const index = state.meters.findIndex( m => m.name === payload.meter )
        if(index === -1) return
        state.meters[index].active = payload.active
        state.meters[index].control = payload.control
    },
    SET_GROUPS(state, value){ 
        state.groupMeters = value
    },
    EDIT_GROUPS(state, value){
        console.log(value)
        console.log(state.groupMeters)
        return state.groupMeters
    },
    ADD_NEW_GROUP(state, value){
        state.groupMeters.push(value)
        console.log(state.groupMeters)
        return state.groupMeters
    },
    SET_METERS_ON(state, value){ state.metersON = value },
    SET_METERS_UP(state, value){ state.metersUP = value },
    SET_METERS_DOWN(state, value){ state.metersDOWN = value },
    SET_METERS_OFF(state, value){ state.metersOFF = value },
    SET_METERS_OUT(state, value){ state.metersOUT = value },
    SET_ARRAY_ON(state, value){ state.arrayON = value },
    SET_ARRAY_UP(state, value){ state.arrayUP = value },
    SET_ARRAY_DOWN(state, value){ state.arrayDOWN = value },
    SET_ARRAY_OFF(state, value){ state.arrayOFF = value },
    SET_ARRAY_OUT(state, value){ state.arrayOUT = value },
    FILTER_METERS(state, value){ state.currMeters = value },
    SET_TEMPS_ARRAY(state, value){ state.arrayTemps = value },
    SET_VAL_TEMPS_ARRAY(state, value){ state.rangeTemps = value },
    SET_RANGES_TEMPS_ARRAY(state, value){ state.rangeArrayTemps = value },
    SET_LIGHT_ARRAY(state, value){ state.arrayLights = value },
    SET_VAL_LIGHT_ARRAY(state, value){ state.rangeLights = value },
    SET_RANGES_LIGHT_ARRAY(state, value){ state.rangeArrayLights = value },
    SET_HUMID_ARRAY(state, value){ state.arrayHumids = value },
    SET_VAL_HUMID_ARRAY(state, value){ state.rangeHumids = value },
    SET_RANGES_HUMID_ARRAY(state, value){ state.rangeArrayHumids = value },
    SET_ARRAY_LINKS(state, value){ state.arrayMeterLinks = value },
    UPDATE_METER_CONTROL(state, payload){
        const index = state.meters.findIndex( m => m.name === payload.meter )
        if(index === -1) return
        state.meters[index].control = payload.control
        state.meters[index].fotocelda = payload.fotocelda
    },
    UPDATE_METER_SCHEDULE(state, payload){
        const index = state.meters.findIndex( m => m.name === payload.meter )
        if(index === -1) return
        if(!state.meters[index].schedule) state.meters[index].schedule = {}
        if(payload.inactive)
            state.meters[index].schedule[payload.control] = null
        else
            state.meters[index].schedule[payload.control] = payload.hours + ':' + payload.minutes
    },
    UPDATE_METER_SUNTIME(state, payload){
        const index = state.meters.findIndex( m => m.name === payload.meter )
        if(index === -1) return
        state.meters[index].suntime = payload.data.active
    },
    SET_METERS(state, meters){
        if(!meters) return
        state.meters = meters
        state.currMeters = meters
    },
    ADD_METERS(state, meters) {
        if(!meters) return
        state.meters.push(...meters)
        return state.meters
    },
    DELETE_METER(state, payload){
        state.meters = state.meters.filter(item => item.circuit !== payload)
        return state.meters
    },
    INSERT_COMMENT(state, comment){
        state.comments.push(comment)
    },
    DISPLAY_COMMENTS(state, comments){
        if(!comments) return
        state.comments = comments
    },
    RETRIEVE_COMMENTS(state, comments){
        if(!comments) return
        state.allComments = comments
    },
    DELETE_COMMENT(state, payload){
        state.comments = state.comments.filter(item => item.creationDate !== payload)
        return
    },
    REPORT_ISSUE(state, payload){
        if(payload.index < 0) return
        let meter = state.meters[payload.index]
        payload.issue = meter.issue
        state.meters[payload.index] = meter
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};